import React from 'react';
import {
  Accordion, AccordionItem, AccordionTrigger, AccordionContent,
} from '@/components/ui/accordion';
import { HelpCircle, Mail, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { FAQ_ITEMS, AAWTA } from '@/lib/aawta';

export const FAQ = () => {
  return (
    <section id="faq" className="py-24 md:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <span className="overline text-aawta-magenta">Frequently Asked</span>
            <h2 className="font-display font-bold text-4xl md:text-5xl mt-4 text-aawta-navy tracking-tight leading-[1.1]">
              Answers, upfront.
            </h2>
            <div className="divider-magenta mt-6" />
            <p className="mt-6 text-[16px] leading-relaxed text-aawta-muted">
              Have another question? Reach our team directly — we respond quickly.
            </p>
            <div className="mt-6 space-y-3">
              <Button
                onClick={() => (window.location.href = `mailto:${AAWTA.email}`)}
                variant="outline"
                data-testid="faq-email-cta"
                className="rounded-full border-aawta-navy text-aawta-navy hover:bg-aawta-navy hover:text-white font-medium px-5"
              >
                <Mail className="mr-2 h-4 w-4" />
                Email us
              </Button>
              <Button
                onClick={() => window.open(AAWTA.calendarUrl, '_blank', 'noopener,noreferrer')}
                variant="ghost"
                data-testid="faq-schedule-cta"
                className="rounded-full border border-aawta-border text-aawta-navy hover:bg-aawta-surface font-medium px-5 ml-0 md:ml-2"
              >
                Book a meeting
                <ExternalLink className="ml-2 h-3.5 w-3.5" />
              </Button>
            </div>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {FAQ_ITEMS.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i + 1}`}
                  className="border-b border-aawta-border last:border-b-0"
                >
                  <AccordionTrigger className="text-left hover:no-underline py-5 group">
                    <span className="flex items-start gap-3 pr-4">
                      <HelpCircle className="h-5 w-5 text-aawta-magenta shrink-0 mt-0.5" strokeWidth={2} />
                      <span className="font-display font-semibold text-[17px] md:text-lg text-aawta-navy group-hover:text-aawta-magenta transition-colors">
                        {item.q}
                      </span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-[15.5px] leading-relaxed text-aawta-muted pl-8 pb-5">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
